export default "__VITE_ASSET__CDhtoxQ2__"